/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_DurationInputs */

const en_media_duration = /** @type {(inputs: Media_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Duration`)
};

const fr_media_duration = /** @type {(inputs: Media_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée média`)
};

const de_media_duration = /** @type {(inputs: Media_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediendauer`)
};

const it_media_duration = /** @type {(inputs: Media_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata del supporto`)
};

const ru_media_duration = /** @type {(inputs: Media_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность медиаконтента`)
};

const es_media_duration = /** @type {(inputs: Media_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración de los medios`)
};

const zh_cn2_media_duration = /** @type {(inputs: Media_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体时长`)
};

const ja_media_duration = /** @type {(inputs: Media_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアの長さ`)
};

const hi_media_duration = /** @type {(inputs: Media_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया अवधि`)
};

const pt_pt2_media_duration = /** @type {(inputs: Media_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração da mídia`)
};

/**
* | output |
* | --- |
* | "Media Duration" |
*
* @param {Media_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_duration = /** @type {((inputs?: Media_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_duration(inputs)
	if (locale === "de") return de_media_duration(inputs)
	if (locale === "it") return it_media_duration(inputs)
	if (locale === "ru") return ru_media_duration(inputs)
	if (locale === "es") return es_media_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_media_duration(inputs)
	if (locale === "ja") return ja_media_duration(inputs)
	if (locale === "hi") return hi_media_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_media_duration(inputs)
	return en_media_duration(inputs)
});